// Styles
import { Wrapper } from "./styles";

interface BotaoProps {
  type: any;
  value: string;
  color: string;
  background: string;
  border: string;
  size: string;
  disabled: boolean;
  onClick: () => void;
}

export default function Botao({
  type,
  value,
  color,
  background,
  border,
  size,
  onClick,
  disabled,
}: BotaoProps) {
  return (
    <Wrapper
      aria-label={value}
      type={type}
      color={color}
      background={background}
      border={border}
      size={size}
      onClick={onClick}
      disabled={disabled}
    >
      {value}
    </Wrapper>
  );
}
